module.exports = __webpack_public_path__ + "static/media/industry.6e57337a.svg";